var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.client
      ? _c(
          "form",
          {
            staticClass: "form__group",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.saveClient()
              }
            }
          },
          [
            !_vm.isScormClientAdmin
              ? _c("div", { staticClass: "account__block" }, [
                  _c("div", { staticClass: "account__block--title" }, [
                    _vm._v(_vm._s(_vm.$t("account.forms.notificationStudents")))
                  ]),
                  _c("div", { staticClass: "form__row" }, [
                    _c(
                      "div",
                      { staticClass: "form__group u-margin-bottom" },
                      [
                        _c("gl-select", {
                          directives: [
                            {
                              name: "skeletor",
                              rawName: "v-skeletor:onChange",
                              value: _vm.selectLang,
                              expression: "selectLang",
                              arg: "onChange"
                            }
                          ],
                          attrs: {
                            id: "config.lang",
                            label: _vm.$t("account.forms.langNotifications"),
                            placeholder: _vm.$t(
                              "account.forms.langNotifications"
                            ),
                            tooltip: _vm.$t(
                              "account.forms.langNotificationsTooltip"
                            ),
                            options: JSON.stringify(_vm.getExtendedLanguages),
                            value: JSON.stringify(_vm.clientData.lang),
                            separator: true,
                            errormessage: !_vm.clientData.lang
                              ? _vm.$t("account.errors.fieldRequired")
                              : null
                          }
                        })
                      ],
                      1
                    ),
                    _vm.subscriptionType === "Users"
                      ? _c(
                          "div",
                          {
                            staticClass: "account__block--checkbox u-margin-top"
                          },
                          [
                            _c("gl-checkbox", {
                              directives: [
                                {
                                  name: "skeletor",
                                  rawName: "v-skeletor:onChange",
                                  value: _vm.setNotifications,
                                  expression: "setNotifications",
                                  arg: "onChange"
                                }
                              ],
                              attrs: {
                                id: "config.notifications.n1",
                                label: _vm.$t(
                                  "account.forms.sendMailActivation"
                                ),
                                tooltip: _vm.$t(
                                  "account.forms.sendMailActivationTooltip"
                                ),
                                checked:
                                  _vm.clientData.notificationsCfg.n1.enabled,
                                small: true
                              },
                              model: {
                                value:
                                  _vm.clientData.notificationsCfg.n1.enabled,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.clientData.notificationsCfg.n1,
                                    "enabled",
                                    $$v
                                  )
                                },
                                expression:
                                  "clientData.notificationsCfg.n1.enabled"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "account__block--checkbox" },
                      [
                        _c("gl-checkbox", {
                          directives: [
                            {
                              name: "skeletor",
                              rawName: "v-skeletor:onChange",
                              value: _vm.setNotifications,
                              expression: "setNotifications",
                              arg: "onChange"
                            }
                          ],
                          attrs: {
                            id: "config.notifications.n4",
                            label: _vm.$t("account.forms.sendMailConfirmation"),
                            tooltip: _vm.$t(
                              "account.forms.sendMailConfirmationTooltip"
                            ),
                            checked: _vm.clientData.notificationsCfg.n4.enabled,
                            small: true
                          },
                          model: {
                            value: _vm.clientData.notificationsCfg.n4.enabled,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.clientData.notificationsCfg.n4,
                                "enabled",
                                $$v
                              )
                            },
                            expression: "clientData.notificationsCfg.n4.enabled"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "account__block--checkbox" }, [
                      _c("div", { staticClass: "checkbox small-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.clientData.notificationsCfg.n3.enabled,
                              expression:
                                "clientData.notificationsCfg.n3.enabled"
                            }
                          ],
                          attrs: {
                            id: "config.sendMailAnimation",
                            type: "checkbox",
                            name: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.clientData.notificationsCfg.n3.enabled
                            )
                              ? _vm._i(
                                  _vm.clientData.notificationsCfg.n3.enabled,
                                  null
                                ) > -1
                              : _vm.clientData.notificationsCfg.n3.enabled
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a =
                                    _vm.clientData.notificationsCfg.n3.enabled,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.clientData.notificationsCfg.n3,
                                        "enabled",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.clientData.notificationsCfg.n3,
                                        "enabled",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.clientData.notificationsCfg.n3,
                                    "enabled",
                                    $$c
                                  )
                                }
                              },
                              _vm.onSendMailAnimationChange
                            ]
                          }
                        }),
                        _c(
                          "label",
                          { attrs: { for: "config.sendMailAnimation" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("account.forms.sendMailAnimation"))
                            )
                          ]
                        )
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "un-btn",
                          attrs: {
                            id: "config.btn-sendMailAnimation",
                            gltooltip: "",
                            type: "button"
                          }
                        },
                        [
                          _c("span", { staticClass: "glicon-info-outline" }),
                          _c("div", { staticClass: "gl-tooltip top center" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.forms.sendMailAnimationTooltip"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    ]),
                    _vm.client.type === "corporate"
                      ? _c(
                          "div",
                          { staticClass: "account__block--checkbox" },
                          [
                            _c("gl-checkbox", {
                              directives: [
                                {
                                  name: "skeletor",
                                  rawName: "v-skeletor:onChange",
                                  value: _vm.setNotifications,
                                  expression: "setNotifications",
                                  arg: "onChange"
                                }
                              ],
                              attrs: {
                                id: "config.notifications.n8",
                                label: _vm.$t(
                                  "account.forms.sendMailKirkpatrick"
                                ),
                                tooltip: _vm.$t(
                                  "account.forms.sendMailKirkpatrickTooltip"
                                ),
                                checked:
                                  _vm.clientData.notificationsCfg.n8.enabled,
                                small: true
                              },
                              model: {
                                value:
                                  _vm.clientData.notificationsCfg.n8.enabled,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.clientData.notificationsCfg.n8,
                                    "enabled",
                                    $$v
                                  )
                                },
                                expression:
                                  "clientData.notificationsCfg.n8.enabled"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.client.type === "corporate"
                      ? _c("div", { staticClass: "account__block--checkbox" }, [
                          _c("div", { staticClass: "checkbox small-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.clientData.referrals,
                                  expression: "clientData.referrals"
                                }
                              ],
                              attrs: {
                                id: "config.referrals",
                                type: "checkbox",
                                name: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.clientData.referrals)
                                  ? _vm._i(_vm.clientData.referrals, null) > -1
                                  : _vm.clientData.referrals
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.clientData.referrals,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.clientData,
                                            "referrals",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.clientData,
                                            "referrals",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.clientData, "referrals", $$c)
                                    }
                                  },
                                  _vm.onReferralChange
                                ]
                              }
                            }),
                            _c(
                              "label",
                              { attrs: { for: "config.referrals" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account.forms.referrals"))
                                )
                              ]
                            )
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "un-btn",
                              attrs: {
                                id: "config.referrals",
                                gltooltip: "",
                                type: "button"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "glicon-info-outline"
                              }),
                              _c(
                                "div",
                                { staticClass: "gl-tooltip top center" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.forms.sendMailReferralsTooltip"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "form__group" },
                      [
                        _c("gl-select", {
                          directives: [
                            {
                              name: "skeletor",
                              rawName: "v-skeletor:onChange",
                              value: _vm.setNotifications,
                              expression: "setNotifications",
                              arg: "onChange"
                            }
                          ],
                          attrs: {
                            id: "config.notifications.n3.weekPeriodicity",
                            label: _vm.$t(
                              "account.forms.emailFrequencyAnimation"
                            ),
                            placeholder: _vm.$t(
                              "account.forms.emailFrequencyAnimation"
                            ),
                            options: JSON.stringify(_vm.frequencyOptions),
                            value: JSON.stringify(
                              _vm.clientData.notificationsCfg.n3.weekPeriodicity
                            ),
                            disabled: !_vm.isN3Enabled,
                            separator: true,
                            errormessage: !_vm.clientData.notificationsCfg.n3
                              .weekPeriodicity
                              ? _vm.$t("account.errors.fieldRequired")
                              : null
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "account__block" }, [
              _c("div", { staticClass: "account__block--title" }, [
                _vm._v(_vm._s(_vm.$t("account.forms.rankingStudents")))
              ]),
              _c("div", { staticClass: "form__row" }, [
                _c(
                  "div",
                  { staticClass: "form__group" },
                  [
                    _c("gl-select", {
                      directives: [
                        {
                          name: "skeletor",
                          rawName: "v-skeletor:onChange",
                          value: _vm.selectRankingFlag,
                          expression: "selectRankingFlag",
                          arg: "onChange"
                        }
                      ],
                      attrs: {
                        id: "config.ranking",
                        label: _vm.$t(
                          "account.forms.rankingVisibilityStudents"
                        ),
                        placeholder: _vm.$t(
                          "account.forms.rankingVisibilityStudents"
                        ),
                        options: JSON.stringify(_vm.rankingOptions),
                        tooltip: _vm.$t(
                          "account.forms.rankingVisibilityStudentsTooltip"
                        ),
                        value: JSON.stringify(_vm.rankingInfo),
                        separator: true,
                        errormessage: !_vm.clientData.ranking
                          ? _vm.$t("account.errors.fieldRequired")
                          : null
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c("div", { staticClass: "account__block" }, [
              _c("div", { staticClass: "account__block--title" }, [
                _vm._v(_vm._s(_vm.$t("account.forms.catalogue")))
              ]),
              _c("div", { staticClass: "form__row" }, [
                !_vm.isScormClientAdmin
                  ? _c(
                      "div",
                      { staticClass: "form__group" },
                      [
                        _c("gl-select", {
                          directives: [
                            {
                              name: "skeletor",
                              rawName: "v-skeletor:onChange",
                              value: _vm.selectDefaultAccessMode,
                              expression: "selectDefaultAccessMode",
                              arg: "onChange"
                            }
                          ],
                          attrs: {
                            id: "config.defaultAccessMode",
                            label: _vm.$t("account.forms.defaultAccessMode"),
                            options: JSON.stringify(
                              _vm.defaultAccessModeOptions
                            ),
                            value: JSON.stringify(
                              _vm.catalogueData.defaultAccessMode
                            ),
                            separator: true,
                            errormessage: !_vm.catalogueData.defaultAccessMode
                              ? _vm.$t("account.errors.fieldRequired")
                              : null
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "form__group" },
                  [
                    _c("gl-select", {
                      directives: [
                        {
                          name: "skeletor",
                          rawName: "v-skeletor:onChange",
                          value: _vm.selectShouldSendDiploma,
                          expression: "selectShouldSendDiploma",
                          arg: "onChange"
                        }
                      ],
                      attrs: {
                        id: "config.shouldSendDiploma",
                        label: _vm.$t("account.forms.shouldSendDiploma"),
                        options: JSON.stringify(_vm.shouldSendDiplomaOptions),
                        value: JSON.stringify(
                          _vm.catalogueData.configuration.shouldSendDiploma
                            ? "enabled"
                            : "disabled"
                        ),
                        separator: true,
                        errormessage:
                          _vm.catalogueData.configuration.shouldSendDiploma ==
                          null
                            ? _vm.$t("account.errors.fieldRequired")
                            : null
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "account__block--buttons" },
              [
                _c("gl-button", {
                  attrs: {
                    id: "config.btn-save",
                    "color-primary": "",
                    type: "submit",
                    text: _vm.$t("account.forms.saveChanges"),
                    disabled: !_vm.dirtyFields
                  },
                  on: {
                    onClick: function($event) {
                      $event.preventDefault()
                      return _vm.saveClient()
                    }
                  }
                })
              ],
              1
            ),
            _vm.configWarning
              ? _c("PopupClientConfig", {
                  on: {
                    close: function($event) {
                      return _vm.close($event)
                    }
                  }
                })
              : _vm._e(),
            _vm.referralWarning
              ? _c("PopupClientReferral", {
                  on: {
                    close: function($event) {
                      return _vm.closeReferral($event)
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }